/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';

import { StyledDetailsTable } from './styles';

const DetailsTable = (props) => {
  const { head, body, striped, /* underlined, */ gridTemplateColumns, className = '', tooltip } = props;

  const [gridTemplateColumnsInternal, setGridTemplateColumnsInternal] = useState('');

  useEffect(() => {
    if (head)
      setGridTemplateColumnsInternal(gridTemplateColumns || head.map(() => 'auto').join(' '));
  }, []);

  return (
    <>
      <StyledDetailsTable
        className={`${striped ? 'detailstable-striped' : ''} ${className}`}
        gridTemplateColumns={gridTemplateColumnsInternal}
      >
        {body && (
          <>
            {head && (
              <article className="detailstable-head">
                {head.map((el) => (
                  <div>{el.toString()}</div>
                ))}
              </article>
            )}
            <article className="detailstable-body">
              {body.map((el, idx1) => (
                <div className="detailstable-row">
                  {el.map((eli, idx2) => (
                    <div className={tooltip ? 'd-flex' : ''}>
                      {parse(eli?.toString() || '')}
                      {tooltip &&
                        tooltip.section === 'body' &&
                        idx1 + 1 === tooltip.row &&
                        idx2 + 1 === tooltip.column && <>{tooltip.component}</>}
                    </div>
                  ))}
                </div>
              ))}
            </article>
          </>
        )}
      </StyledDetailsTable>
    </>
  );
};

export default DetailsTable;
